export const {
    REACT_APP_API_URL,
    REACT_APP_DOCUMENT_CODE,
    REACT_APP_REVISION_NO,
    REACT_APP_EFFECTIVE_DATE,
    REACT_APP_GOOGLE_CLIENT_ID,
} = process.env